import { createRouter, createWebHistory } from 'vue-router'

import Layout from '@/layout/index.vue'

// 公共路由
export const constantRoutes = [
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/index.vue'),
        name: 'Index',
        meta: { title: '首页', icon: 'home', affix: true },
      },
      {
        path: '/accidentManagement',
        name: 'accidentManagement',
        meta: { title: '事故管理', icon: 'accident', affix: true },
        children: [
          {
            path: '/accidentManagement/index',
            component: () => import('@/views/accidentInformation/index.vue'),
            name: 'accidentInformationIndex',
            meta: { title: '事故信息', icon: 'phone', affix: true },
          },
          {
            path: '/accidentInformation/list',
            component: () => import('@/views/accidentInformation/list.vue'),
            name: 'accidentInformationList',
            meta: { title: '事故列表', icon: 'phone', affix: true },
          },
          {
            path: '/accidentInformation/detail/:id',
            component: () => import('@/views/accidentInformation/detail.vue'),
            name: 'accidentInformationDetail',
            meta: { title: '事故详情', icon: 'phone', affix: true },
            show: false, // 不在菜单中显示
          },
        ],
      },
      {
        path: '/deviceManagement',
        name: 'deviceManagement',
        meta: { title: '设备管理', icon: 'equipment', affix: true },
        children: [
          {
            path: '/deviceManagement/aiTripod/1',
            component: () => import('@/views/deviceManagement/aiTripod.vue'),
            name: 'deviceManagementAiTripod',
            meta: { title: 'AI三脚架', icon: 'phone', affix: true },
          },
        ],
      },
      {
        path: '/agreementManagement',
        name: 'agreementManagement',
        meta: { title: '协议管理', icon: 'agreement', affix: true },
        children: [
          {
            path: '/agreementManagement/niuniuEscort',
            component: () => import('@/views/agreementManagement/niuniuEscort.vue'),
            name: 'agreementManagementNiuniuEscort',
            meta: { title: '牛牛护驾', icon: 'phone', affix: true },
          },
          {
            path: '/agreementManagement/wechatMiniProgram',
            component: () => import('@/views/agreementManagement/wechatMiniProgram.vue'),
            name: 'agreementManagementWechatMiniProgram',
            meta: { title: '微信小程序', icon: 'phone', affix: true },
          },
          {
            path: '/agreementManagement/merchantAdmin',
            component: () => import('@/views/agreementManagement/merchantAdmin.vue'),
            name: 'agreementManagementMerchantAdmin',
            meta: { title: '商户后台', icon: 'phone', affix: true },
          },
        ],
      },
      {
        path: '/niuniuHujia',
        name: '牛牛护驾',
        meta: { title: '牛牛护驾', icon: 'numen', affix: true },
        redirect: '/niuniuHujia/banner',
        children: [
          {
            path: '/niuniuHujia/banner',
            component: () => import('@/views/niuniuHujia/banner.vue'),
            name: 'NiuniuHujiaBanner',
            meta: { title: 'Banner管理', icon: 'image', affix: true },
          },
          {
            path: '/niuniuHujia/news',
            component: () => import('@/views/niuniuHujia/news.vue'),
            name: 'NiuniuHujiaNews',
            meta: { title: '资讯管理', icon: 'document', affix: true },
          },
          {
            path: 'articleList/addArticle',
            component: () => import('@/views/niuniuHujia/components/add.vue'),
            name: 'articleList-addArticle',
            meta: {
              title: '发布资讯',
              icon: 'document',
              affix: true,
              hidden: true,
              isMenu: false,
            },
            show: false,
            props: true,
          },
          {
            path: '/niuniuHujia/topic',
            component: () => import('@/views/niuniuHujia/topic.vue'),
            name: 'NiuniuHujiaTopic',
            meta: { title: '话题管理', icon: 'chat-dot-square', affix: true },
          },
          {
            path: '/niuniuHujia/activity',
            component: () => import('@/views/niuniuHujia/activity.vue'),
            name: 'NiuniuHujiaActivity',
            meta: { title: '活动管理', icon: 'calendar', affix: true },
          },
          {
            path: '/niuniuHujia/activity/add',
            component: () => import('@/views/niuniuHujia/components/AddActivity.vue'),
            name: 'NiuniuHujiaActivityAdd',
            meta: {
              title: '新增活动',
              icon: 'calendar',
              affix: false,
              hidden: true,
            },
            show: false,
          },
        ],
      },

      {
        path: '/userManagement',
        name: 'userManagement',
        meta: { title: '用户管理', affix: true },
        children: [
          {
            path: '/userManagement',
            component: () => import('@/views/userManagement/index.vue'),
            name: 'userManagementList',
            meta: { title: '用户列表', affix: true, },
          },
          {
            path: '/userManagement/details',
            component: () => import('@/views/userManagement/details.vue'),
            name: 'userManagementDetails',
            meta: { title: '用户详情', affix: true, hidden: true },
            show: false,
          },
        ],
      },

      {
        path: '/productManagement',
        name: 'productManagement',
        meta: { title: '商品管理', icon: 'goods', affix: true },
        children: [
          {
            path: '/productManagement/publishProduct',
            component: () => import('@/views/productManagement/publishProduct.vue'),
            name: 'publishProduct',
            meta: { title: '发布商品', affix: true },
          },
          {
            path: '/productManagement',
            component: () => import('@/views/productManagement/index.vue'),
            name: 'productManagementList',
            meta: { title: '商品列表', affix: true },
          },
        ],
      },

      {
        path: '/communityManagement',
        name: '社区管理',
        meta: { title: '社区管理', icon: 'community', affix: true },
        children: [
          {
            path: '/communityManagement/pendingReview',
            component: () => import('@/views/communityManagement/pendingReview.vue'),
            name: '待审核',
            meta: { title: '待审核', icon: 'phone', affix: true },
          },
          {
            path: '/communityManagement/report',
            component: () => import('@/views/communityManagement/report.vue'),
            name: '举报',
            meta: { title: '举报', icon: 'phone', affix: true },
          },
          {
            path: '/communityManagement/undercarriage',
            component: () => import('@/views/communityManagement/undercarriage.vue'),
            name: '已下架',
            meta: { title: '已下架', icon: 'phone', affix: true },
          },
          {
            path: '/communityManagement/release',
            component: () => import('@/views/communityManagement/release.vue'),
            name: '已发布',
            meta: { title: '已发布', icon: 'phone', affix: true },
          },
          {
            path: '/contentManagement/index',
            component: () => import('@/views/contentManagement/index.vue'),
            name: '内容管理',
            meta: {
              title: '内容管理',
              icon: 'document',
              affix: true,
              hidden: true,
              isMenu: false,
            },
            props: true,
          },
        ],
      },
      {
        path: '/insurance/index',
        component: () => import('@/views/insurance/index.vue'),
        name: '保险管理',
        meta: { title: '保险管理', icon: 'phone', affix: true },
      },

    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login.vue'),
    hidden: true,
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: constantRoutes,
})

export default router
